import React from 'react';

const Footer = () => (
  <footer className="site-footer">
    <div className="site-footer-inner">
      <p>
        EREBUS CAPITAL PARTNERS LIMITED is registered in England and Wales under Company Number 15492304 and with the FCA as an Appointed Representative with FRN 1011959. EREBUS CAPITAL PARTNERS LIMITED is an Appointed Representative of Finex LLP which is authorised and regulated in the UK by the Financial Conduct Authority (“FCA”) with firm reference number 507537.
      </p>
    </div>
  </footer>
);

export default Footer;
